import OurTeam from "./Team/Our_Team";
import FacultyData from "./Team/Our_Faculty";

import "./Css/Team.css";

function Team() {
  return (
    <div>
      <OurTeam />
      <FacultyData />
    </div>
  );
}

export default Team;
